import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { CiEdit } from "react-icons/ci";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { tableCellClasses } from "@mui/material/TableCell";
import s from "./skill.module.css";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Pagination,
} from "@mui/material";
import { notificationHandler } from "../../utils/Notification";
import Loder from "../../Loder/Loder";
import DataNotFound from "../ErrorPage/DataNotFound";
import { BiFilter, BiSearch } from "react-icons/bi";
import { deleteSkill_api, fetchAllSkills } from "../api/livedarshan";
import { getBaseUrl2 } from "../../utils";

const AllLiveDarshans = () => {
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [allskill, setallskill] = useState([]);
  const [pageCount, setpageCount] = useState(1);
  const [deleteId, setdeleteId] = useState();
  const [deletePopup, setdeletePopup] = useState(false);
  const [currentGroup, setcurrentGroup] = useState({});
  const [pageLength, setpageLength] = useState();
  const [search, setsearch] = useState("");
  useEffect(() => {
    fetchallskillFunc();
  }, [pageCount, search]);

  async function fetchallskillFunc(data) {
    setisLoading(true);
    try {
      const temp = {
        page: pageCount,
        limit: 15,
        search: search.trim(),
      };
      let res = await fetchAllSkills(temp);
      if (res.data.status) {
        console.log(res);
        setpageLength(res?.data?.data?.totalPages);
        setallskill(res.data.data.liveDarshans);
        setisLoading(false);
      } else {
        setisLoading(false);
        console.log("status false!");
      }
    } catch (error) {
      console.log(error);
    }
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "var(--clr-theme)",
      color: theme.palette.common.white,
      fontWeight: "bold",
      borderRight: "1px solid #fff",
      overflow: "hidden",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
      border: "none",
      borderLeft: "2px solid #00000011",
      "&:last-child": {
        borderRight: "2px solid #00000011",
      },
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    borderBottom: "2px solid #00000011",
  }));

  async function deletearticleFunc() {
    setisLoading(true);

    try {
      let res = await deleteSkill_api(deleteId);
      console.log(res);
      if (res.data.status) {
        setisLoading(false);
        setdeletePopup(false);
        fetchallskillFunc();
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        setisLoading(false);
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      console.log(error);
      notificationHandler({ type: "danger", msg: error.message });
    }
  }

  return (
    <div className="container">
      <div className={s["article-list-title"]}>
        <h3>Live Darshans List</h3>
      </div>
      <div className={s["user-list-heading"]}>
        <div className={s["user-list-title"]}>
          <div className="beat_left">
            <div
              className={s["title"]}
              onClick={() =>
                navigate("/add-live-darshans", {
                  state: {
                    pagetype: "Add",
                  },
                })
              }
            >
              <IoMdAdd /> Live Darshans
            </div>
          </div>
        </div>
        <div className={s["user-list-search"]}>
          <div className={s["search-box"]}>
            <span style={{ paddingRight: "0.5rem" }}>
              <BiSearch size={23} />
            </span>
            <input
              type="text"
              spellCheck="false"
              onChange={(e) => {
                setpageCount(1);
                setsearch(e.target.value);
              }}
              placeholder="Search by name..."
            />
          </div>
          <div className={s["filter-btn"]}>
            <span style={{ paddingRight: "2px" }}>
              <BiFilter size={20} />
            </span>
            Filter
          </div>
        </div>
      </div>
      <div className="beat_table" style={{ overflowX: "auto" }}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">Thumbnail</StyledTableCell>
              <StyledTableCell align="center">Title English</StyledTableCell>
              <StyledTableCell align="center">Title Hindi</StyledTableCell>
              <StyledTableCell align="center">Desc English</StyledTableCell>
              <StyledTableCell align="center">Desc Hindi</StyledTableCell>
              <StyledTableCell align="center">Location</StyledTableCell>
              <StyledTableCell align="center">URL</StyledTableCell>
              <StyledTableCell align="center">Tags</StyledTableCell>
              <StyledTableCell align="center">Priority</StyledTableCell>
              {/* <StyledTableCell align="center">isLive</StyledTableCell> */}
              <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allskill.map((row) => (
              <StyledTableRow key={row.id}>
                {/* <StyledTableCell>
                  {(row?.thumbnail?.url) ? (<img src={row?.thumbnail?.url} style={{ width: "50px", height: "50px" }} alt="thumbnail" />) : (<img src={`${getBaseUrl2()}${row?.thumbnail?.url}`} style={{ width: "50px", height: "50px" }} alt="thumbnail" />)
                  }
                </StyledTableCell> */}
                <StyledTableCell>
                  {row?.thumbnail?.provider === "external" ? (
                    <img
                      src={row?.thumbnail?.url}
                      style={{ width: "50px", height: "50px" }}
                      alt="thumbnail"
                    />
                  ) : (
                    <img
                      src={`${getBaseUrl2()}${row?.thumbnail?.url}`}
                      style={{ width: "50px", height: "50px" }}
                      alt="thumbnail"
                    />
                  )}
                </StyledTableCell>

                <StyledTableCell>{row?.titleEnglish} </StyledTableCell>
                <StyledTableCell>{row?.titleHindi} </StyledTableCell>
                <StyledTableCell>{row?.descEnglish} </StyledTableCell>
                <StyledTableCell>{row?.descHindi} </StyledTableCell>
                <StyledTableCell>{row?.location} </StyledTableCell>
                <StyledTableCell>{row?.url} </StyledTableCell>
                <StyledTableCell>{row?.tags + ","} </StyledTableCell>
                {/* <StyledTableCell>{row?.tags} </StyledTableCell> */}
                <StyledTableCell>
                  {row?.priority ? row?.priority : "Not Given"}{" "}
                </StyledTableCell>
                {/* <StyledTableCell align="center">
                  <div style={{ cursor: "pointer" }} className={`${row?.isLive === true ? s.active_admin : s.inactive_admin}`}>
                    {row?.isLive === true ? "Active" : "Inactive"}
                  </div>
                </StyledTableCell> */}
                <StyledTableCell align="center">
                  <CiEdit
                    onClick={() =>
                      navigate("/add-live-darshans", {
                        state: {
                          pagetype: "Edit",
                          data: row,
                        },
                      })
                    }
                    style={{
                      fontSize: "1rem",
                      color: "var(--clr-primary)",
                      marginRight: "0.5rem",
                      cursor: "pointer",
                    }}
                  />
                  <MdDelete
                    onClick={() => {
                      setdeletePopup(true);
                      setcurrentGroup(row);
                      setdeleteId(row._id);
                    }}
                    style={{
                      fontSize: "1rem",
                      color: "var(--clr-primary)",
                      cursor: "pointer",
                    }}
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
        {allskill.length <= 0 && <DataNotFound />}
        {allskill?.length > 0 && (
          <div className={s["pagination"]}>
            <Pagination
              count={pageLength}
              size="large"
              style={{ color: "#D21903" }}
              onChange={(e, value) => setpageCount(value)}
              page={pageCount}
            />
          </div>
        )}
      </div>

      <Dialog
        open={deletePopup}
        aria-labelledby="form-dialog-title"
        maxWidth="xs"
        fullWidth="true"
        onClose={() => setdeletePopup(false)}
      >
        <DialogTitle className={s.dialog_title}>
          <div>Do you want to delete {currentGroup.titleHindi}?</div>
        </DialogTitle>
        <DialogContent className={s.cardpopup_content}>
          <div style={{ display: "flex", gap: "1rem" }}>
            <div
              className={s.employee_gl_popup}
              onClick={() => setdeletePopup(false)}
            >
              Cancel
            </div>
            <div
              className={s.employee_gl_popup_del}
              onClick={() => deletearticleFunc()}
            >
              Delete
            </div>
          </div>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Loder loading={isLoading} />
    </div>
  );
};

export default AllLiveDarshans;
